/* Flavor A/B v2 — custom select synced to existing flavor radios */
(() => {
  const root = document.documentElement;

  function isActive() {
    return root.classList.contains('ab-flavor-v2');
  }

  function isSamplerPackSelectMode(selectEl) {
    return (
      isActive() &&
      root.classList.contains('ab-pack-v1') &&
      root.getAttribute('data-pack-state') === 'sampler' &&
      !!selectEl.closest('#pack-buy-box-sampler-slot')
    );
  }

  // Metafield list → "(1x…, 1x…)"; empty → "(Variant title)"
  function formatSamplerMeta(opt) {
    const flavors = String(opt?.getAttribute('data-sampler-flavors') || '')
      .split('|')
      .map((s) => s.trim())
      .filter(Boolean);
    if (flavors.length) {
      return '(' + flavors.map((name) => '1x' + name).join(', ') + ')';
    }
    const title =
      opt?.dataset.originalLabel ||
      opt?.getAttribute('data-value') ||
      '';
    return title ? '(' + title + ')' : '';
  }

  function getRadios(selectEl) {
    const wrap = selectEl.closest('.variant-wrapper');
    if (!wrap) return [];
    const flavorRadios = Array.from(
      wrap.querySelectorAll(
        '.variant-input-wrap[data-handle="select-flavor"] [data-variant-input], ' +
          '.variant-input-wrap[data-handle="flavor"] [data-variant-input]'
      )
    );
    if (flavorRadios.length) return flavorRadios;
    if (wrap.closest('#pack-buy-box-sampler-slot')) {
      return Array.from(wrap.querySelectorAll('.variant-input-wrap [data-variant-input]'));
    }
    return [];
  }

  function syncTrigger(selectEl) {
    const triggerIcon = selectEl.querySelector('.variant-flavor-select__icon');
    const triggerText = selectEl.querySelector('.variant-flavor-select__text');
    const selected =
      selectEl.querySelector('.variant-flavor-select__option[aria-selected="true"]') ||
      selectEl.querySelector('.variant-flavor-select__option:not([aria-disabled="true"])');
    if (!selected || !triggerText) return;

    if (isSamplerPackSelectMode(selectEl)) {
      selectEl.classList.add('is-sampler-pack');
      const options = Array.from(
        selectEl.querySelectorAll('.variant-flavor-select__option:not([aria-disabled="true"])')
      );
      const index = Math.max(1, options.indexOf(selected) + 1);

      selectEl.querySelectorAll('.variant-flavor-select__option').forEach((opt) => {
        const labelEl = opt.querySelector('.variant-flavor-select__option-label');
        if (labelEl && !opt.dataset.originalLabel) {
          opt.dataset.originalLabel = labelEl.textContent.trim();
        }
      });

      const title = document.createElement('span');
      title.className = 'variant-flavor-select__text-title';
      title.textContent = 'SAMPLER ' + index;
      const meta = document.createElement('span');
      meta.className = 'variant-flavor-select__text-meta';
      meta.textContent = formatSamplerMeta(selected);
      triggerText.replaceChildren(title, meta);

      if (triggerIcon) {
        triggerIcon.removeAttribute('src');
        triggerIcon.hidden = true;
      }

      selectEl.querySelectorAll('.variant-flavor-select__option').forEach((opt, i) => {
        const labelEl = opt.querySelector('.variant-flavor-select__option-label');
        if (!labelEl) return;
        labelEl.textContent = 'SAMPLER ' + (i + 1) + ' ' + formatSamplerMeta(opt);
        const icon = opt.querySelector('.variant-flavor-select__option-icon');
        if (icon) icon.hidden = true;
      });
      return;
    }

    selectEl.classList.remove('is-sampler-pack');
    const label = selected.getAttribute('data-value') || selected.textContent.trim();
    const icon = selected.getAttribute('data-icon') || '';
    triggerText.textContent = label;

    selectEl.querySelectorAll('.variant-flavor-select__option').forEach((opt) => {
      const labelEl = opt.querySelector('.variant-flavor-select__option-label');
      if (labelEl && opt.dataset.originalLabel) {
        labelEl.textContent = opt.dataset.originalLabel;
      }
      const optIcon = opt.querySelector('.variant-flavor-select__option-icon');
      if (optIcon) optIcon.hidden = !opt.getAttribute('data-icon');
    });

    if (triggerIcon) {
      if (icon) {
        triggerIcon.src = icon;
        triggerIcon.hidden = false;
      } else {
        triggerIcon.removeAttribute('src');
        triggerIcon.hidden = true;
      }
    }
  }

  function selectValue(selectEl, value) {
    if (!value) return;
    const radios = getRadios(selectEl);
    const radio = radios.find((r) => r.value === value);
    if (!radio || radio.disabled || radio.classList.contains('disabled')) return;

    selectEl.querySelectorAll('.variant-flavor-select__option').forEach((opt) => {
      opt.setAttribute('aria-selected', opt.getAttribute('data-value') === value ? 'true' : 'false');
    });

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    syncTrigger(selectEl);
    closeSelect(selectEl);
  }

  function openSelect(selectEl) {
    document.querySelectorAll('[data-flavor-select].is-open').forEach((el) => {
      if (el !== selectEl) closeSelect(el);
    });
    const menu = selectEl.querySelector('.variant-flavor-select__menu');
    const trigger = selectEl.querySelector('.variant-flavor-select__trigger');
    if (!menu || !trigger) return;
    menu.hidden = false;
    selectEl.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeSelect(selectEl) {
    const menu = selectEl.querySelector('.variant-flavor-select__menu');
    const trigger = selectEl.querySelector('.variant-flavor-select__trigger');
    if (!menu || !trigger) return;
    menu.hidden = true;
    selectEl.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function syncFromRadios(selectEl) {
    const checked = getRadios(selectEl).find((r) => r.checked);
    if (checked) {
      selectEl.querySelectorAll('.variant-flavor-select__option').forEach((opt) => {
        opt.setAttribute(
          'aria-selected',
          opt.getAttribute('data-value') === checked.value ? 'true' : 'false'
        );
      });
    }
    syncTrigger(selectEl);
  }

  function initSelect(selectEl) {
    if (selectEl.dataset.flavorSelectReady === 'true') {
      syncFromRadios(selectEl);
      return;
    }
    selectEl.dataset.flavorSelectReady = 'true';

    const trigger = selectEl.querySelector('.variant-flavor-select__trigger');
    const menu = selectEl.querySelector('.variant-flavor-select__menu');
    if (!trigger || !menu) return;

    syncFromRadios(selectEl);

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      if (!isActive()) return;
      if (selectEl.classList.contains('is-open')) closeSelect(selectEl);
      else openSelect(selectEl);
    });

    menu.addEventListener('click', (event) => {
      const opt = event.target.closest('.variant-flavor-select__option');
      if (!opt || opt.getAttribute('aria-disabled') === 'true') return;
      selectValue(selectEl, opt.getAttribute('data-value'));
    });

    getRadios(selectEl).forEach((radio) => {
      radio.addEventListener('change', () => syncFromRadios(selectEl));
    });
  }

  function initAll(scope) {
    if (!isActive()) return;
    (scope || document).querySelectorAll('[data-flavor-select]').forEach(initSelect);
  }

  document.addEventListener('click', (event) => {
    if (!isActive()) return;
    if (event.target.closest('[data-flavor-select]')) return;
    document.querySelectorAll('[data-flavor-select].is-open').forEach(closeSelect);
  });

  document.addEventListener('keydown', (event) => {
    if (!isActive() || event.key !== 'Escape') return;
    document.querySelectorAll('[data-flavor-select].is-open').forEach(closeSelect);
  });

  initAll(document);
  new MutationObserver(() => initAll(document)).observe(root, {
    attributes: true,
    attributeFilter: ['class', 'data-pack-state'],
  });

  window.initAbFlavorSelects = initAll;
  window.syncAbFlavorSelectSamplerMode = initAll;
})();
